"use strict";

var _defineProperty = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");
var _slicedToArray = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function get() {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ConnectModal = exports.styles = void 0;
var react_1 = __importStar(require("react"));
var react_device_detect_1 = require("react-device-detect");
var react_modal_1 = __importDefault(require("react-modal"));
var modal_container_1 = __importDefault(require("../components/modal-container"));
var tray_1 = __importDefault(require("../components/tray"));
var constants_1 = require("../constants");
var use_providers_1 = __importStar(require("../hooks/use-providers"));
var use_theme_1 = __importDefault(require("../hooks/use-theme"));
var screens_1 = require("../screens");
var placeholder_1 = __importDefault(require("../screens/placeholder"));
var wallet_connect_1 = require("../screens/wallet-connect");
var use_celo_1 = require("../use-celo");
var colors_1 = require("../utils/colors");
var sort_1 = require("../utils/sort");
var tailwind_1 = __importDefault(require("../utils/tailwind"));
exports.styles = (0, tailwind_1.default)({
  overlay: "tw-z-40\n      tw-fixed\n      tw-inset-0",
  modal: react_device_detect_1.isMobile ? "\n      tw-h-screen\n      tw-w-screen" : "\n      tw-overflow-hidden\n      tw-absolute\n      tw-top-1/2\n      tw-right-auto\n      tw-bottom-auto\n      tw-left-1/2\n      tw--translate-x-1/2\n      tw--translate-y-1/2\n      tw-border-none\n      tw-padding-0\n      tw-rounded-lg\n      tw-drop-shadow\n      dark:tw-drop-shadow",
  portal: "\n    tw-overflow-hidden"
});
function walletToScreen(wallet) {
  var WalletConnectCustomWrapper = function WalletConnectCustomWrapper(_ref) {
    var onSubmit = _ref.onSubmit;
    return react_1.default.createElement(wallet_connect_1.WalletConnect, {
      onSubmit: onSubmit,
      provider: (0, use_providers_1.walletToProvider)(wallet)
    });
  };
  return WalletConnectCustomWrapper;
}
var ConnectModal = function ConnectModal(_ref2) {
  var reactModalProps = _ref2.reactModalProps,
    _ref2$screens = _ref2.screens,
    screens = _ref2$screens === void 0 ? screens_1.defaultScreens : _ref2$screens,
    _ref2$title = _ref2.title,
    title = _ref2$title === void 0 ? 'Connect a wallet' : _ref2$title,
    _ref2$providersOption = _ref2.providersOptions,
    providersOptions = _ref2$providersOption === void 0 ? {} : _ref2$providersOption;
  var _a;
  var theme = (0, use_theme_1.default)();
  var _ref3 = (0, use_celo_1.useCeloInternal)(),
    connectionCallback = _ref3.connectionCallback,
    resetInitError = _ref3.resetInitError;
  var _ref4 = (0, react_1.useState)(''),
    _ref5 = _slicedToArray(_ref4, 2),
    search = _ref5[0],
    setSearch = _ref5[1];
  var _ref6 = (0, react_1.useState)(null),
    _ref7 = _slicedToArray(_ref6, 2),
    adding = _ref7[0],
    setAdding = _ref7[1];
  var onClickProvider = function onClickProvider(provider) {
    resetInitError();
    setAdding(provider);
  };
  var back = (0, react_1.useCallback)(function () {
    resetInitError();
    setSearch('');
    setAdding(null);
  }, [resetInitError, setSearch, setAdding]);
  var close = (0, react_1.useCallback)(function () {
    back();
    connectionCallback === null || connectionCallback === void 0 ? void 0 : connectionCallback(false);
  }, [back, connectionCallback]);
  var onSubmit = (0, react_1.useCallback)(function (connector) {
    connectionCallback === null || connectionCallback === void 0 ? void 0 : connectionCallback(connector);
    back();
  }, [back, connectionCallback]);
  var hideFromDefaults = providersOptions.hideFromDefaults,
    additionalWCWallets = providersOptions.additionalWCWallets,
    _providersOptions$sor = providersOptions.sort,
    sort = _providersOptions$sor === void 0 ? sort_1.defaultProviderSort : _providersOptions$sor,
    _providersOptions$sea = providersOptions.searchable,
    searchable = _providersOptions$sea === void 0 ? true : _providersOptions$sea;
  var _ref8 = (0, react_1.useMemo)(function () {
      var _screens;
      var _wallets = additionalWCWallets || [];
      if (hideFromDefaults) {
        if (hideFromDefaults === true) {
          _screens = {};
        } else {
          _screens = Object.keys(screens).filter(function (x) {
            return !hideFromDefaults.includes(x);
          }).reduce(function (acc, provider) {
            return Object.assign(Object.assign({}, acc), _defineProperty({}, provider, screens[provider]));
          }, {});
        }
      } else {
        _screens = screens;
      }
      return {
        includedDefaultProviders: Object.keys(_screens),
        wallets: _wallets,
        allScreens: _wallets.reduce(function (acc, wallet) {
          acc[wallet.id] = walletToScreen(wallet);
          return acc;
        }, _screens)
      };
    }, [screens, hideFromDefaults, additionalWCWallets]),
    wallets = _ref8.wallets,
    allScreens = _ref8.allScreens,
    includedDefaultProviders = _ref8.includedDefaultProviders;
  var providers = (0, use_providers_1.default)(wallets, includedDefaultProviders, sort, search);
  var ProviderElement = adding && (allScreens === null || allScreens === void 0 ? void 0 : allScreens[adding]);
  var content = ProviderElement ? react_1.default.createElement(ProviderElement, {
    onSubmit: onSubmit,
    provider: constants_1.PROVIDERS[adding]
  }) : react_1.default.createElement(placeholder_1.default, null);
  return react_1.default.createElement(react_modal_1.default, Object.assign({
    portalClassName: exports.styles.portal,
    htmlOpenClassName: 'react-celo-modal-open-html',
    bodyOpenClassName: 'react-celo-modal-open-body',
    isOpen: !!connectionCallback,
    className: exports.styles.modal,
    overlayClassName: exports.styles.overlay
  }, reactModalProps, {
    onRequestClose: close,
    style: {
      content: {
        background: theme.background
      },
      overlay: Object.assign({
        background: (0, colors_1.hexToRGB)(theme.background, 0.75)
      }, (_a = reactModalProps === null || reactModalProps === void 0 ? void 0 : reactModalProps.style) === null || _a === void 0 ? void 0 : _a.overlay)
    },
    shouldCloseOnOverlayClick: !react_device_detect_1.isMobile,
    ariaHideApp: false
  }), react_1.default.createElement(modal_container_1.default, {
    onClose: close,
    onBack: back,
    selectedProvider: adding,
    tray: react_1.default.createElement(tray_1.default, Object.assign({
      providers: providers,
      title: title,
      onClickProvider: onClickProvider,
      selectedProvider: adding
    }, searchable && {
      search: search,
      onSearch: function onSearch(str) {
        return setSearch(str);
      }
    })),
    content: content
  }));
};
exports.ConnectModal = ConnectModal;